import styled from 'styled-components';
import { maxMobile, maxWidth, retina } from 'Utils/utilsStyle';
import SkeletonCustom from './SkeletonCustom';

const StyleWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
.skeleton-box {
  &:nth-child(2) {
    width: 406px;
    min-width: 406px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 390px;
      min-width: 390px;
    }
    @media all and (max-width: ${maxMobile}) {
      width: 290px;
      min-width: 290px;
    }
  }
}
`;

const ArticleDrawerHeadingSkeleton = function ArticleDrawerHeadingSkeleton() {
  return (
    <StyleWrapper>
      {[1, 2].map(() => (
        <SkeletonCustom
          width="257px"
          height="30px"
          margin="0px 0px 12px 0px"
          marginSm="0px 0px 12px 0px"
        />
      ))}
    </StyleWrapper>
  );
};

export default ArticleDrawerHeadingSkeleton;
